import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FireIcon(props) {
  return /*#__PURE__*/_jsxs("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5Z",
      fill: "#9E5400"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5Z",
      stroke: "#9E5400"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.0615 1.76758C10.3084 1.62903 10.6119 1.75241 10.7383 2.00586C11.3302 3.19267 12.2654 4.22469 13.5 4.9375C16.848 6.87049 17.9955 11.152 16.0625 14.5C14.1295 17.848 9.84801 18.9953 6.5 17.0625C3.15203 15.1295 2.00469 10.848 3.9375 7.5C4.10585 7.20841 4.29234 6.9334 4.49414 6.67578C4.69574 6.41844 5.08459 6.45727 5.28711 6.71387C5.5648 7.06579 5.88103 7.38613 6.22949 7.66797C6.56213 7.937 7.01636 7.61901 7.00293 7.19141C7.00094 7.12786 7 7.06403 7 7C7 6.08147 7.20624 5.21088 7.5752 4.43262C8.10835 3.30803 8.98185 2.37542 10.0615 1.76758ZM10.7617 8.07227C10.5995 8.04102 10.4339 8.10399 10.3301 8.23242C9.49829 9.26225 9.00001 10.5731 9 12C9 12.1428 9.00484 12.2845 9.01465 12.4248C9.03587 12.729 8.80833 13.0069 8.50586 12.9688C7.93779 12.8967 7.39032 12.7024 6.9043 12.4043C6.53001 12.1748 5.99726 12.3894 6.09082 12.8184C6.47975 14.6015 8.08685 15.9999 10 16C12.2091 16 14 14.2091 14 12C14 10.0512 12.6067 8.42783 10.7617 8.07227Z",
      fill: "#FCF1E6"
    })]
  });
}